import { Vector3 } from 'three'

export function getWorldPosition(x: number, y: number, width: number, height: number) {
  const offsetX = (width - 1) / 2
  const offsetZ = (height - 1) / 2

  const worldX = x - offsetX
  const worldZ = y - offsetZ

  return new Vector3(worldX, 0, worldZ)
}

export function normalizeAngle(raw: number, prev: number): number {
  const diff = ((raw - prev + Math.PI * 3) % (Math.PI * 2)) - Math.PI
  return prev + diff
}
